export default {"src":"/_next/static/media/cu.288be974.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};